/** NOTE - To future developer
 * JMac copied this directly from Andy's work in feat/bookings
 * so he could use the FileUploader component.
 * I hope this doesn't cause you too much rebasing woe.
 * TODO - Please delete this comment once feat/bookings is merged
 */
import { useEffect } from 'react'

export function useDebounceEffect(fn, waitTime, deps = []) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps)
        }, waitTime)

        return () => {
            clearTimeout(t)
        }
    }, deps)
}
